<template>
  <vue-scroll
    v-if="filteredTabs.length"
    class="flex flex-row w-full h-full shrink-0 overflow-y-hidden border-solid border-0 border-b border-standard-border"
    :ops="{
      scrollPanel: { scrollingY: false },
      rail: { gutterOfSide: '2px', gutterOfEnds: '8px' },
      bar: { size: '4px' },
    }"
  >
    <div class="mention-tabs flex flex-row p-2 gap-1">
      <div
        v-for="tabKey in filteredTabs"
        :key="tabKey + selectedIndex"
        class="mention-tab flex rounded px-2 py-1"
        :class="{
          'mention-tab--active': indexInGorupRange(tabKey, selectedIndex),
          'cursor-pointer': hasResults(tabKey),
          'text-gray-500': !hasResults(tabKey),
        }"
        @click="selectTab(tabKey)"
      >
        <span class="mention-tab__title text-sm whitespace-nowrap">
          {{ tabLabel(tabKey) }}
        </span>
      </div>
    </div>
  </vue-scroll>
</template>

<script>
export default {
  name: 'MentionTabs',
  props: {
    results: {
      type: Object,
      required: true,
    },
    selectedIndex: {
      type: Number,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
      default: '',
    },
    tabsOrder: {
      type: Array,
      required: true,
    },
  },

  emits: ['tabClick'],

  computed: {
    filteredTabs() {
      return this.tabsOrder.filter(
        (tabKey) => this.results[this.resultKey(tabKey)].length || this.searchQuery === ''
      );
    },
  },

  methods: {
    tabLabel(tabKey) {
      return this.translate(tabKey);
    },
    resultKey(tabKey) {
      return tabKey === 'spaces' ? 'projects' : tabKey;
    },
    hasResults(tabKey) {
      return this.results[this.resultKey(tabKey)].length;
    },
    selectTab(tabKey) {
      const tabStartIndex = this.getTabStartIndex(tabKey);
      const hasResults = this.hasResults(tabKey);
      if (!hasResults) return;
      this.$emit('tabClick', tabStartIndex, tabKey);
    },
    getTabStartIndex(tabKey) {
      let startIndex = 0;
      for (const key of this.tabsOrder) {
        const orderKey = this.resultKey(key);
        if (key === tabKey) {
          break;
        }
        if (this.results.hasOwnProperty(orderKey)) {
          startIndex += this.results[orderKey].length;
        }
      }
      return startIndex;
    },
    indexInGorupRange(tabKey, index = this.selectedIndex) {
      let within = false;
      let total = 0;

      for (const key of this.tabsOrder) {
        const orderKey = this.resultKey(key);
        if (this.results.hasOwnProperty(orderKey)) {
          const tabLength = this.results[this.resultKey(orderKey)].length;
          if (key === tabKey) {
            within = index >= total && index < total + tabLength;
            break;
          }
          total += tabLength;
        }
      }

      return within;
    },
  },
};
</script>
<style lang="scss">
.mention-tabs {
  .mention-tab {
    &--active {
      @apply bg-activeItem-default;
    }
  }
}
</style>
